/**
 * @generated SignedSource<<d19771d28258a6d28d6c1c5eeacbd5a7>>
 * @relayHash a0a1b06cb72cf0d6a9f27115871761ed
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a0a1b06cb72cf0d6a9f27115871761ed

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteProgressNotesInput = {
  ids: ReadonlyArray<string>;
};
export type deDeleteProgressNotesMutation$variables = {
  connections: ReadonlyArray<string>;
  input: De_deleteProgressNotesInput;
};
export type deDeleteProgressNotesMutation$data = {
  readonly deleteProgressNotes: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly progressNote: ReadonlyArray<{
      readonly id: string;
    }> | null;
  };
};
export type deDeleteProgressNotesMutation = {
  response: deDeleteProgressNotesMutation$data;
  variables: deDeleteProgressNotesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deDeleteProgressNotesMutation",
    "selections": [
      {
        "alias": "deleteProgressNotes",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteProgressNotesPayload",
        "kind": "LinkedField",
        "name": "de_deleteProgressNotes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "de_ProgressNote",
            "kind": "LinkedField",
            "name": "de_ProgressNote",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deDeleteProgressNotesMutation",
    "selections": [
      {
        "alias": "deleteProgressNotes",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteProgressNotesPayload",
        "kind": "LinkedField",
        "name": "de_deleteProgressNotes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "progressNote",
            "args": null,
            "concreteType": "de_ProgressNote",
            "kind": "LinkedField",
            "name": "de_ProgressNote",
            "plural": true,
            "selections": [
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a0a1b06cb72cf0d6a9f27115871761ed",
    "metadata": {},
    "name": "deDeleteProgressNotesMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a1937d946051039ce1237c0bcaab5939";

export default node;
